import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import Navigation from 'components/Navigation';
import { loadPropertyDetail } from 'ducks/propertyDetail';
import './ReportStepLayout.css';
import { LOADER } from 'constants/loader';

function ReportStepLayout(props) {
    const {
        dispatch,
        location,
        match,
        propertyDetail,
        children,
    } = props;

    const parsedPropertyId = useMemo(
        () => parseInt(match.params.propertyId, 10),
        [match.params.propertyId]
    );

    useEffect(() => {
        if (parsedPropertyId !== propertyDetail.propertyId) {
            // This would fire the loader in the redux state
            // This would get unloaded when the Rapid Search has finished loading
            // See actionCreators/comparableItems.js -> fetchComparableItems in the finally block
            setTimeout(() => {
                dispatch({ type: LOADER });
            });
            dispatch(loadPropertyDetail(parsedPropertyId));
        }
    }, []);

    return (
        <div className="report-step-layout">
            <div className="top-section">
                <Container maxWidth="lg">
                    <Navigation propertyId={parsedPropertyId} pathname={location.pathname}/>
                </Container>
            </div>
            {children}
        </div>
    );
}

ReportStepLayout.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    featureFlags: PropTypes.object.isRequired,
    propertyDetail: PropTypes.object.isRequired,
    reportType: PropTypes.object.isRequired,
    children: PropTypes.node,
};

const mapStateToProps = (state) => ({
    propertyDetail: state.propertyDetail,
    featureFlags: state.featureFlags,
    reportType: state.reportType,
});

export default connect(mapStateToProps)(ReportStepLayout);